/**
 * The one framework display-name helper (I18N-R09). School screens and the
 * document link sheet both use it, so a framework reads the same everywhere.
 */

export interface NamedFramework {
  framework_key: string;
  name?: Readonly<Record<string, string | undefined>> | null;
}

/**
 * Name in the UI language, then English, then Turkish, then the framework key.
 * Turkish is only shown in a non-Turkish UI when it is the only name there is.
 */
export function frameworkDisplayName(framework: NamedFramework, language: string): string {
  const name = framework.name || {};
  return name[language] || name.en || name.tr || framework.framework_key;
}
